// extracted by mini-css-extract-plugin
export default {"container":"AverageProgressReport_container__ZN685","date":"AverageProgressReport_date__1VtuV","main":"AverageProgressReport_main__XkqIc","info":"AverageProgressReport_info__dvT-2"};